import { EventTypeInputRating } from '../types/ViewModel/EventTypeInputRating';
import { EventTypeInputRatingBM } from '../types/BusinessModel/EventTypeInputRatingBM';

export class EventTypeInputRatingFactory {
    public newEventTypeInputRating(eventTypeInputRating: EventTypeInputRatingBM): EventTypeInputRating {
        return new EventTypeInputRating(
            eventTypeInputRating.eventTypeInputRatingId,
            eventTypeInputRating.eventTypeInputId,
            eventTypeInputRating.numberOfIcons,
            eventTypeInputRating.iconNumberText,
            eventTypeInputRating.commentMandatoryNumbers
        );
    }

    public createEventTypeInputRating(eventTypeInputRating: EventTypeInputRating | null): EventTypeInputRating | null {
        if (eventTypeInputRating) {
            return new EventTypeInputRating(
                eventTypeInputRating.eventTypeInputRatingId,
                eventTypeInputRating.eventTypeInputId,
                eventTypeInputRating.numberOfIcons,
                eventTypeInputRating.iconNumberText,
                eventTypeInputRating.commentMandatoryNumbers
            );
        }
        return null;
    }
}
